import { ReactComponent as IconSortUp } from '../../icons/Icon-Sort-Up.svg';
import { ReactComponent as IconSortDown } from '../../icons/Icon-Sort.svg';
import './ArrowsSortIcon.scss';

export const SORT_STATE = {
  DEFAULT: 'default',
  ASC: '01',
  DESC: '02',
  HOVER: 'hover',
  HOVER_ASC: 'hover_01',
  HOVER_DESC: 'hover_02'
};

/**
 * ArrowsSortIcon — clickable sort indicator for table column headers.
 *
 * @param {string}   sortState  One of SORT_STATE values (default/01/02/hover/hover_01/hover_02)
 * @param {function} onClick    Called when the button is activated
 * @param {string}   ariaLabel  Accessible label describing the column being sorted
 */
const ArrowsSortIcon = ({
  sortState = SORT_STATE.DEFAULT,
  onClick,
  ariaLabel = 'Sort'
}) => {
  const isAsc =
    sortState === SORT_STATE.ASC || sortState === SORT_STATE.HOVER_ASC;
  const isDesc =
    sortState === SORT_STATE.DESC || sortState === SORT_STATE.HOVER_DESC;
  const isHover = sortState.startsWith('hover');
  const isActive = isAsc || isDesc;

  const Icon = isAsc ? IconSortUp : IconSortDown;

  let ariaSort = 'none';
  if (isAsc) ariaSort = 'ascending';
  if (isDesc) ariaSort = 'descending';

  return (
    <button
      type="button"
      className={[
        'arrows-sort-icon',
        isActive ? 'arrows-sort-icon--active' : '',
        isHover ? 'arrows-sort-icon--hover' : ''
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={onClick}
      aria-label={ariaLabel}
      aria-sort={ariaSort}
    >
      <Icon className="arrows-sort-icon__svg" />
    </button>
  );
};

export default ArrowsSortIcon;
